module.exports = __webpack_public_path__ + "static/media/done-2.523c939f.png";